export default __webpack_public_path__ + "static/media/tce-horiz-logo-color-white-text-white-outline@2x.73ed1785.png";